export type DeviceTier = 'audio_only' | 'smart_display' | 'legacy' | 'mid' | 'modern';

interface CastDeviceCapabilities {
  IS_VIDEO_SUPPORTED?: boolean;
  IS_AUDIO_SUPPORTED?: boolean;
  IS_TOUCH_SUPPORTED?: boolean;
}

export function getDeviceTier(): DeviceTier {
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();
  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  const ua = navigator.userAgent ?? '';

  const isAndroidTV = ua.includes('Android TV');
  const isChromecast = ua.includes('CrKey') || ua.includes('Chromecast');
  const isFuchsia = ua.includes('Fuchsia');
  const isGoogleTV = ua.includes('Google TV');

  if (caps.IS_VIDEO_SUPPORTED === false) {
    return 'audio_only';
  }

  if (caps.IS_TOUCH_SUPPORTED || isFuchsia) {
    return 'smart_display';
  }

  const isLikely4KDevice = isAndroidTV || isGoogleTV || ua.includes('Ultra');

  if (isLikely4KDevice) {
    return 'modern';
  }

  if (isChromecast) {
    return 'mid';
  }

  return 'legacy';
}

export function getDeviceCapabilities(): string[] {
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();
  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  return (Object.keys(caps) as (keyof CastDeviceCapabilities)[]).filter((key) => caps[key] === true);
}
